import React, { useState, useEffect } from 'react';
import { serverUrl } from '../socket';

// Avatar robuste : affiche l'image (via le proxy CORS du serveur) quand une URL
// est disponible, sinon une pastille avec l'initiale. L'etat d'erreur est gere
// en state (pas de mutation imperative de src) -> zero flicker meme en re-render.

function hashCode(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) { h = ((h << 5) - h) + str.charCodeAt(i); h |= 0; }
  return Math.abs(h);
}

function initial(label) {
  const cleaned = (label || '?').toString().replace(/^[^a-zA-Z0-9]+/, '');
  const ch = cleaned.charAt(0) || (label || '?').toString().charAt(0) || '?';
  return ch.toUpperCase();
}

export function Avatar({ url, label, className, size = 40, forCapture = false }) {
  const [errored, setErrored] = useState(false);
  useEffect(() => { setErrored(false); }, [url]);

  if (url && !errored) {
    const src = `${serverUrl}/img-proxy?url=${encodeURIComponent(url)}`;
    return (
      <img
        src={src}
        alt={label || ''}
        className={className}
        onError={() => setErrored(true)}
        {...(forCapture ? { crossOrigin: 'anonymous', referrerPolicy: 'no-referrer', 'data-external-img': '1' } : {})}
      />
    );
  }

  const hue = hashCode((label || '?').toString()) % 360;
  return (
    <span
      className={className}
      aria-label={label || ''}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        background: `hsl(${hue}, 60%, 55%)`,
        color: '#fff',
        fontWeight: 700,
        fontSize: Math.floor(size * 0.42),
        lineHeight: 1,
        userSelect: 'none',
        overflow: 'hidden',
      }}
    >
      {initial(label)}
    </span>
  );
}
